import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import './ShippingPortalLayout.scss';
import { Permissions } from '@lanterds/types';
import { FmtpPage } from 'src/components/common/NavigationMenu/types';
import { PAGE_INFO, SELECTED_SHIPPING_PORTAL_TYPE_LOCAL_STORAGE_KEY } from 'src/util/constants';
import { SideNavContext } from 'src/components/common/NavigationMenu/SideNav/SideNavContext';
import { getShipmentTypeFromContext, getUserEmailFromToken } from 'src/util/helpers';
import { isAuthorized } from 'src/util/Permissions';
import PermissionsError from 'src/components/common/PermissionsError/PermissionsError';

export default function ShippingPortalLayout() {
    const userEmail = getUserEmailFromToken();

    const { setSelectedSideNavItem, setSideNavPages } = useContext(SideNavContext);

    const shippingType = getShipmentTypeFromContext(SELECTED_SHIPPING_PORTAL_TYPE_LOCAL_STORAGE_KEY, 'type');

    const { subPages } = PAGE_INFO.shippingPortal ?? {};
    const [transferPage, returnPage, outboundPage] = subPages ?? [];

    // ALSO ADD NEW PERMISSIONS TO NavigationMenu.tsx
    const isTransfersAuthorized = isAuthorized(userEmail, Permissions.shippingPortal_transfers);
    const isReturnsAuthorized = isAuthorized(userEmail, Permissions.shippingPortal_returns);
    const isOutboundAuthorized = isAuthorized(userEmail, Permissions.shippingPortal_outbound);

    const shippingPortalSideNavLinks: FmtpPage[] = [];

    if (isTransfersAuthorized) shippingPortalSideNavLinks.push(transferPage);
    if (isReturnsAuthorized) shippingPortalSideNavLinks.push(returnPage);
    if (isOutboundAuthorized) shippingPortalSideNavLinks.push(outboundPage);

    useEffect(() => {
        setSideNavPages(shippingPortalSideNavLinks);
    }, []);

    useEffect(() => {
        if (shippingType) {
            setSelectedSideNavItem(shippingType);
            localStorage.setItem(SELECTED_SHIPPING_PORTAL_TYPE_LOCAL_STORAGE_KEY, shippingType);
        }
    }, [shippingType]);

    return <>{isTransfersAuthorized || isReturnsAuthorized || isOutboundAuthorized ? <Outlet /> : <PermissionsError />}</>;
}
